import useKeenAutoplayPlugin from "@/shared/components/keen-slider/plugins/keen-autoplay-plugin";
import KeenSlider from "keen-slider";

export class BenefitSlider {
    private _element: JQuery;

    constructor(element: JQuery) {
        this._element = element;
        this.constructSlider();
    }

    public static init() {
        const nodes = $(".benefit-slider");
        for (const element of nodes) {
            new BenefitSlider($(element));
        }
    }

    private constructSlider() {
        new KeenSlider(
            this._element[0],
            {
                vertical: true,
                selector: ".benefit",
                slides: {
                    origin: "center",
                    perView: 1,
                    spacing: 20,
                },
                defaultAnimation: {
                    duration: 800,
                },
                created: (slider) => {
                    this._element.find(".benefit-slider__button--prev").on("click", function () {
                        slider.prev();
                    });

                    this._element.find(".benefit-slider__button--next").on("click", function () {
                        slider.next();
                    });
                },
            },
            [useKeenAutoplayPlugin()],
        );
    }
}
